import type {
  ApiOnboardingGraph,
  PlaybookVersionNoGraph,
  PrerequisiteSource,
} from '@onefootprint/request-types/dashboard';

/** Doubles as the prefix the drawer shows next to each key and as the identity of a prerequisite across versions. */
export const prerequisitePrefix = { vault: 'vault.', onboarding_data: 'data.' } as const;

const getPrerequisiteId = (source: PrerequisiteSource) =>
  source.kind === 'vault'
    ? `${prerequisitePrefix.vault}${source.di}`
    : `${prerequisitePrefix.onboarding_data}${source.key}`;

/** For a graph in hand: an uncommitted draft, or the version an edit session started from. */
export const requiredPrerequisiteIds = (graph: ApiOnboardingGraph) =>
  graph.nodes
    .flatMap(node => (node.kind === 'prerequisite' ? node.prerequisites : []))
    .filter(prerequisite => prerequisite.isRequired)
    .map(getPrerequisiteId);

/** For committed versions, which carry their prerequisites without the graph. */
export const versionPrerequisiteIds = (versions: PlaybookVersionNoGraph[]) =>
  versions
    .flatMap(version => version.prerequisites)
    .filter(prerequisite => prerequisite.isRequired)
    .map(getPrerequisiteId);
